/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionhistoryheading2Inputs */

const en_actionhistoryheading2 = /** @type {(inputs: Actionhistoryheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier actions`)
};

const de_actionhistoryheading2 = /** @type {(inputs: Actionhistoryheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frühere Aktionen`)
};

/**
* | output |
* | --- |
* | "Earlier actions" |
*
* @param {Actionhistoryheading2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionhistoryheading2 = /** @type {((inputs?: Actionhistoryheading2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionhistoryheading2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionhistoryheading2(inputs)
	return de_actionhistoryheading2(inputs)
});
export { actionhistoryheading2 as "actionHistoryHeading" }